import {NgModule} from '@angular/core';
import {DocumentsDownloadComponent} from "./documents-download.component";
import {DlsSharedModule} from "../dls-shared.module";

@NgModule({
  imports: [
    DlsSharedModule
  ],
  declarations: [DocumentsDownloadComponent]
})
export class DocumentsDownloadModule {
}


